"use client"

import { FileChartColumnIncreasing } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FileChartColumnIncreasingIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FileChartColumnIncreasingIcon = component(Icon)({
  as: FileChartColumnIncreasing,
})
